module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-roman.581167fa.woff2";